import Link from 'next/link';
import { useRouter } from 'next/router';
import classes from './ArticleCard.module.scss';

const ArticleCard = ({ data, ctaText }) => {
    const router = useRouter();
    const { image, title, intro_text } = data.attributes;

    return (
        <div className={classes.oArticleCard}>
            {image?.data?.attributes?.url?.length > 0 && (
                <div
                    className={classes.mCardImage}
                    style={{
                        backgroundImage: `url(${image.data.attributes.url})`
                    }}
                ></div>
            )}

            <div className={classes.mCardBody}>
                <h3 className={`${classes.aTitle} fnt30`}>{title}</h3>
                <div className={`${classes.mText} fnt16f fnt-pm`}>{intro_text}</div>
                <Link
                    href={{
                        pathname: `articles/${data.attributes.slug}`,
                        query: `lang=${router.query?.lang || router.defaultLocale}`
                    }}
                >
                    <a className={`${classes.aTextLink} aTextLink fnt-xb`}>{ctaText}</a>
                </Link>
            </div>
        </div>
    );
};

export default ArticleCard;
